import React from 'react';

import Table from 'reactstrap/es/Table';
import Button from 'reactstrap/es/Button';
import Input from 'reactstrap/es/Input';
import { YoApiComponentList } from '@yooink/yorestapi/frontend/es/YoApiComponent';
import SimplePagination from '@yooink/youi/es/SimplePagination';
import Api from './Api';
import ItemRow from './ItemRow';

class I18nEditor extends YoApiComponentList {
	getApi = () => Api;

	getBaseUrl = () => '/';

	create = async () => {
		try {
			await this.setState({
				disabled: true
			});
			await this.getApi().create({});
			await this.fetch();
		} finally {
			await this.setState({
				disabled: false
			});
		}
	};

	onSave () {

	}

	loadDefaults = () => {
		if (window.confirm('Вы уверены?')) {
			this.getApi().loadDefaults().then(() => this.fetch());
		}
	}

	render () {
		const { items, disabled } = this.state;
		return (
			<div>
				<div className="d_title">Редактор системной локализации</div>
				<div className="d_box">
					<div className="d_box-header">
						<Button disabled={disabled} onClick={this.create} color="link" className="btn_main">
							Создать
						</Button>
					</div>
					<Table>
						<thead>
							<tr>
								<th style={{ fontWeight: 500 }}>_id</th>
								<th>
									<Input placeholder="Ключ" onChange={(e) => this.onChangeSearch('key', e.target.value)} onBlur={this.fetch} />
								</th>
								<th>
									<Input placeholder="RU" onChange={(e) => this.onChangeSearch('value.ru', e.target.value)} onBlur={this.fetch} />
								</th>
								<th>
									<Input placeholder="EN" onChange={(e) => this.onChangeSearch('value.en', e.target.value)} onBlur={this.fetch} />
								</th>
								<th>
									<Input placeholder="CS" onChange={(e) => this.onChangeSearch('value.cs', e.target.value)} onBlur={this.fetch} />
								</th>
								<th style={{ fontWeight: 500 }}>
									Экспорт
								</th>
								<th />
							</tr>
						</thead>
						<tbody>
							{items.map((item) => (
								<ItemRow key={item._id} item={item} fetch={() => this.fetch()} />
							))}
						</tbody>
					</Table>
					{this.state.count > this.state.limit
						? (
							<SimplePagination
								offset={this.state.offset}
								limit={this.state.limit}
								count={this.state.count}
								showCount={10}
								setOffcet={(offset) => this.setState({ offset }, this.fetch)}
							/>
					) : null}
					<span onClick={this.loadDefaults}>Загрузить обновления с файла локализации</span>
				</div>
			</div>
		);
	}
}

export default I18nEditor;
